import { Toaster as Sonner } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-slate-900 group-[.toaster]:text-white group-[.toaster]:border-blue-900/50 group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-gray-300",
          actionButton:
            "group-[.toast]:bg-blue-600 group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-slate-700 group-[.toast]:text-gray-300",
          success: "group-[.toast]:bg-slate-900 group-[.toast]:border-green-500/50",
          error: "group-[.toast]:bg-slate-900 group-[.toast]:border-red-500/50",
        },
      }}
      {...props} />
  );
}

export { Toaster }
